import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { isObject, isScrollBehaviorSupported, modifyPrototypes, nonFinite, now, original, step } from "./common.js";
export var elementScroll = function elementScroll(element, options) {
  var _a, _b;

  var originalBoundFunc = original.elementScroll.bind(element);

  if (options.left === undefined && options.top === undefined) {
    return;
  }

  var startX = element.scrollLeft;
  var startY = element.scrollTop;
  var targetX = nonFinite((_a = options.left) !== null && _a !== void 0 ? _a : startX);
  var targetY = nonFinite((_b = options.top) !== null && _b !== void 0 ? _b : startY);

  if (options.behavior !== "smooth") {
    return originalBoundFunc(targetX, targetY);
  }

  var removeEventListener = function removeEventListener() {
    window.removeEventListener("wheel", cancelScroll);
    window.removeEventListener("touchmove", cancelScroll);
  };

  var context = {
    timeStamp: now(),
    duration: options.duration,
    startX: startX,
    startY: startY,
    targetX: targetX,
    targetY: targetY,
    rafId: 0,
    method: originalBoundFunc,
    timingFunc: options.timingFunc,
    callback: removeEventListener
  };

  var cancelScroll = function cancelScroll() {
    cancelAnimationFrame(context.rafId);
    removeEventListener();
  };

  window.addEventListener("wheel", cancelScroll, {
    passive: true,
    once: true
  });
  window.addEventListener("touchmove", cancelScroll, {
    passive: true,
    once: true
  });
  step(context);
};
export var elementScrollPolyfill = function elementScrollPolyfill(animationOptions) {
  if (isScrollBehaviorSupported()) {
    return;
  }

  var originalFunc = original.elementScroll;
  modifyPrototypes(function (prototype) {
    return prototype.scroll = function scroll() {
      if (arguments.length === 1) {
        var scrollOptions = arguments[0];

        if (!isObject(scrollOptions)) {
          throw new TypeError("Failed to execute 'scroll' on 'Element': parameter 1 ('options') is not an object.");
        }

        return elementScroll(this, _objectSpread(_objectSpread({}, scrollOptions), animationOptions));
      }

      return originalFunc.apply(this, arguments);
    };
  });
};